export default {
  name: 'Instruction',
  functional: true,
  render(createElement, { props }) {
    return createElement('h6', props.label);
  },
};
